import projectoverview from "../../../../assets/images/docs/projects/selector.png";
import bookmarksoverview from "../../../../assets/images/docs/projects/bookmarks.png";
import addproject from "../../../../assets/images/docs/projects/addproject.png";
import projecticon from "../../../../assets/images/docs/projects/icon.png";
import projectbookmarks from "../../../../assets/images/docs/projects/addbookmark.png";
import * as React from 'react';
export default {
  projectoverview,
  bookmarksoverview,
  addproject,
  projecticon,
  projectbookmarks,
  React
};